import React, { FC } from 'react';

interface SVGBurgerIconProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGBurgerIcon: FC<SVGBurgerIconProps> = ({
  width = '32',
  height = '32',
  color = '#6140FF',
  strokeWidth = '2',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10H24"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 16H24"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 22H24"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGBurgerIcon;
